module.exports = __webpack_public_path__ + "img/loginbing.588f7387.jpg";